import { Component, Input, OnInit } from '@angular/core';
import { ViewWillEnter } from '@ionic/angular';
import { ReportTableComponent } from '../../../../common/components/report-table/report-table.component';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { Time } from '@angular/common';
import { getTime } from 'date-fns';
import { GtrakAuthService } from '../../../../../app/features/authentication/services/gtrak-auth.service';
import { RequestParams } from '../../../../common/rest-api/models/request-params';
import { GRouteStopService } from '../../services/g-route-stops.service';
import { RouteStopModel } from '../../models/route-stop.model';
import { RouteModel } from '../../models/route.model';
import { GRouteService } from '../../services/g-route.service';

@Component({
  selector: 'app-logsheet-page',
  templateUrl: 'logsheet.page.html',
  styleUrls: [
     './logsheet.page.scss',
     '../../styles/g-route.styles.scss'
  ]
})
export class LogSheetPage implements ViewWillEnter, OnInit {

    currentNavRoute: string;

    requestParams: RequestParams;

    routeStops: RouteStopModel[];
    allRouteStops: RouteStopModel[];
    currentRoute: RouteModel;
    currentRouteDetail: RouteModel;

    showAllStops: boolean = false;
    loaded: boolean = false;
    currentDate:Date;
    currentWeek:number;
    currentDay:number;
    breadcrumbs= [];

    constructor(
        private router: Router,
        private authService: GtrakAuthService,
        private stopService: GRouteStopService,
        private routeService: GRouteService,
    ) { 
        this.currentRoute = null;
    }
    async ngOnInit(): Promise<void> {
        this.loaded = false;
        this.showAllStops=true;
        if(!this.authService.user.canViewDriverRoutes) {
            this.router.navigate([this.authService.user.homeLocation]);
        }

        await this.getStop();
        this.breadcrumbs.push({ label: 'Home', url: '/route' });
        this.loaded = true;
    }
    
    async getStop():Promise<void>{
        this.currentNavRoute = this.router.url;
        this.requestParams = new RequestParams();
        this.requestParams.setOrdering('ServiceTime', 'asc');
        this.requestParams.setPaging(1, 0);
        this.requestParams.filters.RouteCode = this.authService.user.routeCode;
        this.currentRoute = await this.routeService.get(this.authService.user.routeCode);
        this.currentDate= this.authService.user.routeDate
        this.currentWeek=this.currentRoute.getWeek(this.authService.user.routeDate);
        this.currentDay=this.currentRoute.getDay(this.authService.user.routeDate);
        this.requestParams.filters.DayOfPeriod = this.currentRoute.frequencyOffset(this.authService.user.routeDate);
        try{
        let date = new Date(this.authService.user.routeDate);
        let day = String(date.getDate()).padStart(2, '0');
        let month = String(date.getMonth() + 1).padStart(2, '0'); 
        let year = date.getFullYear();
        let formattedDate = `${year}-${month}-${day}`;
        var stopData = await this.stopService.getStops(formattedDate, this.requestParams);
        stopData.results.forEach((r: any) => {
            const logDate = r.routeLogs?.filter(rl => rl.logType === 2)[0]?.logDate ?? null;
            var hours = 0;
            var minutes=0;
            if (logDate) {
                var estlogDate=new Date(logDate);
                hours = estlogDate.getHours(); 
                minutes = estlogDate.getMinutes();
               var minutesStr = String(minutes).padStart(2, '0');
                hours = hours % 12 || 12;
                r.arrival = `${hours}:${minutesStr}`;
            } else {
                r.arrival = null;
            }
        });

    }
    catch(error ){

    }
    if(stopData!=undefined){
         this.allRouteStops=stopData.results;
        this.routeStops =stopData.results;
    }
    }
    async ionViewWillEnter(): Promise<void> {
        this.loaded=false;
        this.showAllStops=true;
          await this.getStop();
       if(this.routeStops!=undefined){
        this.routeStops=[...this.routeStops];
       }
       this.loaded=true;

    }
    ngAfterViewChecked() {
       
    }
   
    showAllToggle(): void {
        this.routeStops = this.showAllStops ? this.allRouteStops : this.allRouteStops.filter(a => !a.routeLogs.find(r => r.logType === 3));
    }

}